import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'

import ContactSidebar from './sidebar/sidebar.component'
import ContactToolbar from './toolbar/toolbar.component'
import ContactList from './list/list.component'

import { getContacts, downloadContactData, openModal, statusType } from '../../../actions'
import { format, getPageSize, THEMES } from '../../../utils'

import './landing.page.scss'
import { Banner } from '../../../components'

/**
 * Contact landing Page
 */
class ContactLandingPage extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      isSidebarCollapsed: true,
      filters: {
        query: '',
        partialGDPR: false,
        status: null,
        limit: getPageSize('contact-list') || 10,
        page: 1
      }
    }
  }

  /**
   * Component did mount
   */
  componentDidMount () {
    this.getContacts()
  }

  /**
   * Get Contacts
   */
  getContacts = () => {
    const { getContacts } = this.props
    const { filters } = this.state
    getContacts(filters)
  }

  /**
   * Opens contact modal
   */
  onContactCreate = () => {
    const { openModal } = this.props

    openModal({
      type: 'CONTACT_FORM',
      props: {
        onSaveSuccess: this.getContacts.bind(this)
      }
    })
  }

  /**
   * Handle toggling of isSidebarCollapsed state
   */
  toggleSidebar = () => {
    const { isSidebarCollapsed } = this.state
    this.setState({
      isSidebarCollapsed: !isSidebarCollapsed
    })
  }

  /**
   * Fetch contacts based on provided filters
   * @param filters
   */
  handleFilterChange = (filters) => {
    this.setState(
      { filters: { ...this.state.filters, ...filters } },
      () => this.getContacts()
    )
  }

  /**
   * Reset filters
   */
  handleFilterReset = () => {
    this.setState({
        filters: {
          ...this.state.filters, ...{
            page: 1,
            partialGDPR: false,
            status: null
          }
        }
      },
      () => this.getContacts()
    )
  }

  /**
   * Handle grid csv export
   */
  handleExport = () => {
    const { filters } = this.state
    const { downloadContactData } = this.props
    const file = {
      name: `Contact Export - ${moment().format('DD/MM/YY')}`,
      type: 'csv'
    }

    downloadContactData({ filters, file })
  }

  /**
   * Render Contact List
   * @returns {*}
   */
  render () {
    const { contacts: { data, total, maxTotal, status, initialLoading }, exportStatus, history } = this.props
    const { filters, isSidebarCollapsed } = this.state

    return (
      <>
        <Banner
          title={`Contacts (${format(total || 0)})`}
          icon='q4i-contact-2pt'
          controls={[
            {
              label: 'Add Contact',
              theme: THEMES.CITRUS,
              onClick: this.onContactCreate
            }
          ]} />

        <div className='contact-landing-page_grid'>
          <ContactSidebar
            filters={filters}
            isSidebarCollapsed={isSidebarCollapsed}
            onFilterChange={this.handleFilterChange}
            onFilterReset={this.handleFilterReset} />

          <div className='contact-landing-page_grid-body page_grid'>
            <ContactToolbar
              noData={!data || !data.length}
              toggleSidebar={this.toggleSidebar}
              exportStatus={exportStatus}
              handleExport={this.handleExport}
              handleFilterChange={this.handleFilterChange} />

            <ContactList
              isGridReady={!initialLoading}
              loading={status === statusType.IN_PROGRESS}
              data={data}
              filters={filters}
              history={history}
              total={(total > maxTotal) ? maxTotal : total}
              handleFilterChange={this.handleFilterChange} />
          </div>
        </div>
      </>
    )
  }
}

ContactLandingPage.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    contacts: state.contact.contacts,
    exportStatus: state.contact.contactExport.status
  }
}

const mapDispatchToProps = (dispatch) => ({
  getContacts: bindActionCreators(getContacts, dispatch),
  downloadContactData: bindActionCreators(downloadContactData, dispatch),
  openModal: bindActionCreators(openModal, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactLandingPage)